import { link } from "fs";
import { routes } from "../../routers/routes";
import { MenuItem } from "../../types/Layout";

export const menuList: MenuItem[] | undefined = [
  
  {
    title : "MapView",
    Items:[
      {
        id : 1,
        title : "MapView",
        type:"link",
         icon: "icon-map",
         url: routes.MapView,
      },
     
    ]
  },
  {
    title: "OmsList",
    Items:[
       {
          id:2,
          title:"OMS list",
          type:"link",
          icon:"icon-omsList", 
          url:routes.OmsList
       }
    ]
  },
  {
    title : "Dashboard",

    Items:[
       {
          id:3,
          title:"DashBoard",
          type:'link',
          icon: "icon-dashboard",
          url :routes.DashBoard
       }
    ]

 },


 
  {
    title: "Configuration",
    Items: [
     
      
      {
        id:4,
        title: "Distributary/Zone",
        type: "link",
        icon: "icon-zone",
        url: routes.DistributaryZoneList,
      },
      {
        id:5,
        title: "Scheme/Village",
        type: "link",
        icon: "icon-village",
        url: routes.SchemeVillageList,
      },
      {
        id:6,
        title: "Chak",
        type: "link",
        icon: "icon-chack",
        url: routes.ChackList,
      },
      {
        id : 7,
        title : "Chak Valve Detail",
        type : "link",
        icon : "icon-valve",
        url : routes.ChackValveDetail,
      },
     
     
      {
        id : 8,
        title : "Email",
        type : "link",
        icon : "icon-emails",
        url : routes.EmailList,
      },
      {
        id:9,
        title: "Chak Instrument",
        type: "link",
        icon: "icon-chackinstrument",
        url: routes.ChackInstrument,
      },
      {
        id:10,
        title: "Users",
        type: "link",
        icon: "icon-person",
        url: routes.Users,
      },
      {
        id:11,
        title:"Beneficiary",
        type:'link',
        icon:"icon-khasara",
        url:routes.BeneficiaryList
      },
      {
        id:12,
        title:"Wua",
        type:'link',
        icon:"icon-wualeader",
        url:routes.WuaList
      },
     
      
     
    ],
  },
  {
    title :"Settings",
    Items : [
       {
         id:13,
         title:"UploadKml",
         type:"link",
         icon: "icon-kml",
         url : routes.KmlList,


       },
       {
        id:14,
        title:"Project Settings",
         type:"link",
         icon: "icon-project",
         url : routes.ProjectList,
       },
       {
         id:15,
         title:"Email Sender",
         type:"link",
         icon: "icon-emailsender",
         url : routes.EmailSender,
       },
       
       {
          id:16,
          title:"Reports",
          type:"link",
          icon:"icon-report",
          url: routes.report
       }
      
    ]
  },
   {
     title:'Pumping Station',
     Items:[
         {
           id:17,
           title:'Pumping Station',
           type:"link",
           icon:'icon-alarm',
           url:routes.PumpingStationList
         },
         {
          id:18,
          title:'Get Volume Report',
          type:'link',
          icon:'icon-dailyvolume',
          url:routes.GetReportPumpingStation
         },
         {
          id:19,
          title:'Power Consumption',
          type:'link',
          icon:'icon-powerconsumption',
          url:routes.PowerConsuumption
         }
     ]
   },
  {
    title : "Alarms",
    Items : [
      {
        id : 20,
        title : "Active Alarms",
        type:"link",
        icon:"icon-alarm",
        url:routes.Alarms

      }
    ]
  },
  {
     title : 'Trends',
     Items :[
        {
           id:21,
           title:'Trends',
           type:'link',
           icon:'icon-trends',
           url:routes.Trends
        }
     ]
  },
  {
    title : 'Schedule',
    Items :[
       {
          id:22,
          title:'Group',
          type:'link',
          icon:'icon-group',
          url:routes.Group
       },
       {
        id:23,
          title:'Schedule Group',
          type:'link',
          icon:'icon-schedulegroup',
          url:routes.AddChakInGroup
       },
       {
        id:24,
        title:'Group Scheduler',
        type:'link',
        icon:'icon-groupscheduler',
        url:routes.GroupScheduler
       },
       {
        id:25,
        title:'Schedule Status',
        type:'link',
        icon:'icon-groupscheduler',
        url:routes.ScheduleStatus
       }
    ]
 }
  
  
  
];
